import { useState } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { MainProfileLayout } from './MainProfileLayout';
import { deleteUser } from '../../services/user.service';
import { useAuthStore } from '../../stores/authStore';

export const DeleteProfilePage = () => {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const [isDeleting, setIsDeleting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onDelete = async () => {
    setErrorMessage('');
    setIsDeleting(true);

    try {
      await deleteUser();
      logout();
      navigate('/main');
    } catch (error: any) {
      setErrorMessage(error?.message || 'Unable to delete profile');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <MainProfileLayout section="delete">
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 2 }}>
        Delete Profile
      </Typography>

      <Stack spacing={2} sx={{ maxWidth: 680 }}>
        {errorMessage ? <Alert severity="error">{errorMessage}</Alert> : null}

        <Typography>
          Are you sure you want to delete your profile? This will delete all of your spaces and
          cannot be undone.
        </Typography>

        <Stack direction="row" justifyContent="flex-end">
          <Button color="error" variant="contained" onClick={onDelete} disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </Stack>
      </Stack>
    </MainProfileLayout>
  );
};
